import ExportButtons from "../../../components/admin/common/ExportButtons";
import Header from "../../../components/admin/common/Header";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import Sidebar from "../../../components/admin/common/Sidebar";
import AdminMaintainer from "../../../components/admin/users/AdminMaintainer";
import AdminUserTable from "../../../components/admin/users/AdminUserTable";
import { useAdmins, useMaintainer } from "../../../hooks/useAdmins";
import { useUserModulePermissions } from "../../../hooks/useUserModulePermissions";
import { getCookie } from "../../../utils";

const UserList = () => {
  const {
    data: adminsData,
    refetch: refetchAdmins,
    isLoading: isLoadingAdmins,
    isError: isErrorAdmins,
  } = useAdmins({ limit: 10 });

  const {
    data: maintainersData,
    refetch: refetchMaintainers,
    isLoading: isLoadingMaintainers,
    isError: isErrorMaintainers,
  } = useMaintainer();

  const role = getCookie("role");
  const userId = getCookie("userId");

  const { data: permissionsData } = useUserModulePermissions(
    "Admin Portal Users",
    userId,
    {
      enabled: role === "maintainer" && !!userId,
    }
  );
  console.log(permissionsData, "permissionsData");

  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      <div className="h-full">
        <div className="sticky top-0 h-screen text-white">
          <Sidebar />
        </div>
      </div>

      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] overflow-hidden">
        <PageWrapper>
          <div className="flex flex-col h-full">
            <div className="flex-1 p-4 overflow-y-auto">
              <Header
                title="Admin Portal - Users List"
                desc="View and manage admins and maintainers"
              />

              {/* Admins Section */}
              <h2 className="text-xl font-semibold mb-2 mt-4">Admins</h2>
              {isLoadingAdmins ? (
                <div>Loading admins...</div>
              ) : isErrorAdmins || !adminsData ? (
                <div className="text-red-500">Failed to load admins</div>
              ) : (
                <>
                  <ExportButtons model="admins" />
                  <AdminUserTable
                    permissionsData={permissionsData?.data ?? null}
                    users={adminsData.data.admins}
                    refetch={refetchAdmins}
                  />
                </>
              )}

              <h2 className="text-xl font-semibold mt-8 mb-2">Maintainers</h2>
              {isLoadingMaintainers ? (
                <div>Loading maintainers...</div>
              ) : isErrorMaintainers || !maintainersData ? (
                <div className="text-red-500">Failed to load maintainers</div>
              ) : (
                <>
                  <ExportButtons model="maintainers" />
                  <AdminMaintainer
                    permissionsData={permissionsData?.data ?? null}
                    users={maintainersData.data}
                    refetch={refetchMaintainers}
                  />
                </>
              )}
            </div>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default UserList;
